// extracted by mini-css-extract-plugin
export default {"root":"Dropdown_root__C0o-M","menuContent":"Dropdown_menuContent__SrpsI","menuItem":"Dropdown_menuItem__RM-wr","menuItemDisabled":"Dropdown_menuItemDisabled__sopj5"};